import {  useState } from 'react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'

import { Helper, ICreateUser, UserDto, UserProfileService } from 'app/modules/core'

const initForm: ICreateUser = {
    userName: '',
    newPassword: '',
    passwordConfirmation: '',
}

const passwordFormValidationSchema = Yup.object().shape({
    userName: Yup.string(),
    newPassword: Yup.string()
        .min(6, 'Minimum 6 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Password is required'),
    passwordConfirmation: Yup.string()
        .min(6, 'Minimum 6 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Password is required')
        .oneOf([Yup.ref('newPassword'), null], 'Passwords must match'),
})

type ICreateUserPasswordProps = {
    userProfileId: string
    onSaved:()=>void
}

export const CreateUserPassword: React.FC<ICreateUserPasswordProps> = (props) => {
   
    const [createUser, setCreateUser] = useState<ICreateUser>(initForm)
    const [showPasswordForm, setPasswordForm] = useState<boolean>(false)
    const [loading2, setLoading2] = useState(false)

    const formik2 = useFormik<ICreateUser>({
        initialValues: {
            ...initForm,
        },
        validationSchema: passwordFormValidationSchema,
        onSubmit: (values) => {
            setLoading2(true)
            setTimeout(() => {
                const newUser: UserDto = {
                    userName: values.userName,
                    passWord: values.newPassword,
                }

                if (props.userProfileId)
                    UserProfileService.CraeteUser(props.userProfileId, newUser)
                        .then(() => {

                            toast.success('Save Success.')
                            props.onSaved()
                        })
                        .catch((ex) => {
                            debugger
                            toast.error(Helper.catchErrorMsg(ex))
                        })

                setCreateUser(values)
                setLoading2(false)
                setPasswordForm(false)
            }, 1000)
        },
    })

    return (
        <>
            <div className='d-flex flex-wrap align-items-center mb-10'>
                <div id='kt_signin_password' className={' ' + (showPasswordForm && 'd-none')}>
                    <div className='fs-6 fw-bolder mb-1'>UserName</div>
                    <div className='fw-bold text-gray-600'>{createUser.userName}</div>
                </div>

                <div
                    id='kt_signin_password_edit'
                    className={'flex-row-fluid ' + (!showPasswordForm && 'd-none')}
                >
                    <form
                        onSubmit={formik2.handleSubmit}
                        id='kt_signin_change_password'
                        className='form'
                        noValidate
                    >
                        <div className='row mb-1'>
                            <div className='col-lg-4'>
                                <div className='fv-row mb-0'>
                                    <label htmlFor='currentpassword' className='form-label fs-6 fw-bolder mb-3'>
                                        UserName
                                    </label>
                                    <input
                                        type='text'
                                        className='form-control form-control-lg form-control-solid '
                                        id='userName'
                                        {...formik2.getFieldProps('userName')}
                                    />
                                    {formik2.touched.userName && formik2.errors.userName && (
                                        <div className='fv-plugins-message-container'>
                                            <div className='fv-help-block'>{formik2.errors.userName}</div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className='col-lg-4'>
                                <div className='fv-row mb-0'>
                                    <label htmlFor='newpassword' className='form-label fs-6 fw-bolder mb-3'>
                                        New Password
                                    </label>
                                    <input
                                        type='password'
                                        className='form-control form-control-lg form-control-solid '
                                        id='newpassword'
                                        {...formik2.getFieldProps('newPassword')}
                                    />
                                    {formik2.touched.newPassword && formik2.errors.newPassword && (
                                        <div className='fv-plugins-message-container'>
                                            <div className='fv-help-block'>{formik2.errors.newPassword}</div>
                                        </div>
                                    )}
                                </div>
                                <div className='form-text mb-5'>
                                    Password must be at least 8 character and contain symbols
                                </div>
                            </div>

                            <div className='col-lg-4'>
                                <div className='fv-row mb-0'>
                                    <label htmlFor='confirmpassword' className='form-label fs-6 fw-bolder mb-3'>
                                        Confirm New Password
                                    </label>
                                    <input
                                        type='password'
                                        className='form-control form-control-lg form-control-solid '
                                        id='confirmpassword'
                                        {...formik2.getFieldProps('passwordConfirmation')}
                                    />
                                    {formik2.touched.passwordConfirmation && formik2.errors.passwordConfirmation && (
                                        <div className='fv-plugins-message-container'>
                                            <div className='fv-help-block'>{formik2.errors.passwordConfirmation}</div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className='d-flex'>
                            <>
                                <button
                                    id='kt_password_submit'
                                    type='submit'
                                    className='btn btn-primary me-2 px-6'
                                >
                                    {!loading2 && 'Create User'}
                                    {loading2 && (
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            Please wait...{' '}
                                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                        </span>
                                    )}
                                </button>
                                <button
                                    onClick={() => {
                                        setPasswordForm(false)
                                    }}
                                    id='kt_password_cancel'
                                    type='button'
                                    className='btn btn-color-gray-400 btn-active-light-primary px-6'
                                >
                                    Cancel
                                </button>
                            </>
                        </div>
                    </form>
                </div>

                <div
                        id='kt_signin_password_button'
                        className={'ms-auto ' + (showPasswordForm && 'd-none')}
                    >
                        <button
                            onClick={() => {
                                setPasswordForm(true)
                            }}
                            className='btn btn-light btn-active-light-primary'
                        >
                            Create User
                        </button>
                    </div>
            </div>
        </>
    )
}
